module.exports = __webpack_public_path__ + "static/media/club-mahindra.565e1b0a.svg";